import { CONTACT_DETAILS } from '../constants';
import { PhoneIcon, EmailIcon, LocationIcon, BuildingIcon } from './Icons';

const iconMap = {
  phone: PhoneIcon,
  email: EmailIcon,
  location: LocationIcon,
  building: BuildingIcon,
};

const ContactUs = () => {
  return (
    <section className="contact" id="contact" aria-label="Get a free quote">
      <div className="contact__container container">
        <div className="contact__header">
          <p className="contact__eyebrow">Get in Touch</p>
          <h2 className="contact__title">
            Ready to transform your <em>outdoor space</em>?
          </h2>
          <p className="contact__sub">
            Give us a call, send an email, or book online — we're here to help.
          </p>
        </div>

        <div className="contact__info">
          <div className="contact__details">
            {CONTACT_DETAILS.map((detail) => {
              const IconComponent = iconMap[detail.icon];
              return (
                <div key={detail.id} className="contact-detail">
                  <div className="contact-detail__icon" aria-hidden="true">
                    {IconComponent && <IconComponent />}
                  </div>
                  <div className="contact-detail__body">
                    <span className="contact-detail__label">
                      {detail.label}
                    </span>
                    {detail.href ? (
                      <a className="contact-detail__value" href={detail.href}>
                        {detail.value}
                      </a>
                    ) : (
                      <span className="contact-detail__text">
                        {detail.value}
                      </span>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
